import React from "react";
import PageHeader from "../../components/common/PageHeader";
import PageMeta from "../../components/common/PageMeta";
import FeatureImgContentThree from "../../components/feature-img-content/FeatureImgContentThree";
import FeatureImgEight from "../../components/features/FeatureImgEight";
import RequestForDemo from "../../components/others/RequestForDemo";
import PromoThree from "../../components/promo/PromoThree";
import FooterOne from "../../layout/Footer/FooterOne";
import Navbar from "../../layout/Header/Navbar";
import Layout from "../../layout/Layout";
import { useParams } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";

const segmentoMap = {
  education: "educacao",
  educacao: "educacao",
  logistics: "logistica",
  logistica: "logistica",
  streaming: "streaming",
  "retail": "varejo-e-moda",
  "retail-e-fashion": "varejo-e-moda",
  "varejo-e-moda": "varejo-e-moda",
  betting: "bets-igaming",
  "bets-igaming": "bets-igaming",
  financial: "financeiro",
  financeiro: "financeiro",
  startups: "startups",
  tecnologia: "tecnologia",
  technology: "tecnologia",
  agribusiness: "agronegocio",
  agronegocio: "agronegocio"
};

const SingleService = () => {
  const { segmento } = useParams();
  console.log(segmento);
  const { t } = useLanguage();
  const segmentoKey = segmentoMap[segmento] || segmento;
  console.log(segmentoKey);

  const conteudo = {
    title: t(`services.${segmentoKey}.title`),
    desc: t(`services.${segmentoKey}.desc`),
    features: {
      title: t(`services.${segmentoKey}.features.title`),
      description: t(`services.${segmentoKey}.features.description`),
      items: t(`services.${segmentoKey}.features.items`)
    },
    analytics: {
      title: t(`services.${segmentoKey}.analytics.title`),
      description: t(`services.${segmentoKey}.analytics.description`),
      items: t(`services.${segmentoKey}.analytics.items`)
    }
  };

  // Fallback content if service not found
  if (!conteudo.title || conteudo.title.startsWith('services.')) {
    conteudo.title = "Serviço não encontrado";
    conteudo.desc = "O segmento informado não existe.";
  }

  return (
    <Layout>
      <PageMeta title={conteudo.title} />
      <Navbar classOption="navbar-light" />
      <PageHeader title={conteudo.title} desc={conteudo.desc} />
      <FeatureImgEight 
        title={conteudo.features?.title}
        description={conteudo.features?.description}
        items={conteudo.features?.items}
      />
      <FeatureImgContentThree 
        title={conteudo.analytics?.title}
        description={conteudo.analytics?.description}
        items={conteudo.analytics?.items}
      />
      <PromoThree hasBg />
      <RequestForDemo />
      <FooterOne footerLight />
    </Layout>
  );
};

export default SingleService;
